import {createAction} from "@reduxjs/toolkit";

export const setEventPlaces = createAction('SET_EVENT_PLACES');